// Gets the route in the "hash" part of the url - but ignores query parameters if they exist.
export const extractPathFromHash = (hash) => {
    return hash.split('?')[0].replace('#', '');
};
